Accounts = require 'lib/accounts'
l = require 'lib/localize'
moment = require 'moment'
f = require 'effing'
xtend = require 'xtend'

module.exports = (model, Features, otherData) ->
  data = {}
  data.paidAccount = model.get('paidAccount')
  data.key = data.id = model.id
  data.statementUrl = "#{model.urlRoot}/#{model.id}/paidAccount/statement"
  data.salesTaxForSubscriberUrl = "#{model.urlRoot}/#{model.id}/paidAccount/salesTaxForSubscriber"

  currentProductNumber = data.paidAccount?.products?[0]
  yearlyEquivalent = Features.getYearlyEquivalent(currentProductNumber)

  if currentProductNumber?
    if date = data.paidAccount.billingDates?[currentProductNumber]
      data.nextBillingDate = moment(new Date(date)).format('LL')

  data.yearlyEquivalent = yearlyEquivalent
  data.yearlyEquivalentPrice = Features.getPrice(yearlyEquivalent)
  data.yearlyEquivalentTotalPrice = model.totalPerUserPrice?(yearlyEquivalent)
  data.yearlyDiscountPercent = Features.getYearlyDiscountPercent(yearlyEquivalent, currentProductNumber)

  data.price = Features.getPrice(currentProductNumber)

  data.billingStrategy = model.getBillingStrategy(currentProductNumber)
  if Features.isPerUser(currentProductNumber)
    data.nextChargeAmount = model.totalPerUserPrice(currentProductNumber)
  else
    data.nextChargeAmount = Features.getPrice(currentProductNumber)

  data.current = Features.currentPriceObjectForModel(model)

  data.canSwitchToYearly = ->
    !Features.isUpgrade(currentProductNumber) && Features.getYearlyEquivalent(currentProductNumber)?

  data.activeAccount = Accounts.isActive(data.paidAccount)
  standing = data.paidAccount?.standing
  data.hasAccount = Accounts.hasAccount(standing)
  data.processingAccount = Accounts.isProcessing(standing)
  data.problemAccount = Accounts.isProblem(standing) # aka overdue

  data.willExpire = Accounts.willExpire(data.paidAccount)
  if data.willExpire && currentProductNumber?
    if date = data.paidAccount.expirationDates[currentProductNumber]
      data.expirationDate = moment(new Date(date)).format('LL')
  if (accountStanding = Accounts.standingName(model.get('paidAccount')?.standing))?
    data.accountStanding = accountStanding
    data.accountStandingDisplay = l(['account standing', accountStanding])

  # you've actively cancelled
  data.cancelledAccount = Accounts.isCancelled(data.paidAccount)

  # you're so overdue, we've cancelled your account. enter a new cc
  data.needCC = Accounts.needsCC(data.paidAccount?.standing)

  xtend data, otherData



// WEBPACK FOOTER //
// ./app/scripts/views/billing/internal/billing-data-from-model.coffee